import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { useRedux } from 'util/hook/redux';

import { wrapFetch } from 'util/api';
import { updateProduct } from './product';

// Static entry appended only to the navigation-facing category list (see `useNavigationCategory`
// below) — kept out of the raw `useCategory` data so it doesn't leak into the footer sitemap,
// collection filter tabs, or product filter sidebar, which also read from `useCategory`.
export const NAVIGATION_STATIC_CATEGORIES = [
	{
		id: 'customer-service',
		name: '客戶服務',
		disableLink: true,
		children: [
			{
				id: 'customer-service-news',
				name: '最新消息',
				externalUrl: 'https://www.yuanyu.tw/camera/news.php',
				children: [],
			},
			{
				id: 'customer-service-member',
				name: '會員專區',
				externalUrl: 'https://www.yuanyu.tw/camera/blog/2000/01/09/member/',
				children: [],
			},
			{
				id: 'customer-service-course',
				name: '課程資訊',
				externalUrl: 'https://members.yuanyu.tw/course',
				children: [],
			},
		],
	},
];

export const getCategory = createAction('GET_CATEGORY', () => async dispatch => {
	const { status, data } = await wrapFetch('product/category');

	if (status !== 200) {
		return { data: [] };
	}

	const result = data.map(item => ({
		...item,
		products: item.products.map(product => {
			dispatch(updateProduct(product.id, product));
			return product.id;
		}),
	}));

	return { data: result };
});

const reducer = {
	category: handleActions(
		{
			GET_CATEGORY_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_CATEGORY_FULFILLED: (state, action) => ({
				...state,
				data: action.payload.data,
				loading: false,
			}),
		},
		{
			data: [],
			loading: false,
		},
	),
};

const mapHooksToState = createSelector(
	state => state.category.data,
	data => ({ category: data }),
);

export const useCategory = () => useRedux(mapHooksToState);

export const useNavigationCategory = () => {
	const [{ category }, actions] = useRedux(mapHooksToState);

	return [{ category: [...category, ...NAVIGATION_STATIC_CATEGORIES] }, actions];
};

export const searchCategoryName = (categoryList, categoryId) => {
	const result = categoryList.filter(category => categoryId === category.id);

	if (result.length !== 0) {
		return result[0].name;
	}

	for (let i = 0; i < categoryList.length; i += 1) {
		const newName = searchCategoryName(categoryList[i].children, categoryId);

		if (newName !== '') {
			return newName;
		}
	}

	return '';
};

export default { reducer };
